import { DMY_CASUAL_LONG_FORMAT } from 'constants/dateFormats'
import { getFormattedDateByTimezone } from 'lib/experiences/experienceUtils'

type OfferMetadata = Pick<App.ExperienceOffer, 'id' | 'expirationDate' | 'location'>

export default function getDrawerBookableUntilDate(offer?: OfferMetadata): string | undefined {
  if (!offer?.expirationDate || !offer.id.startsWith('led') || !offer.location?.timezone) {
    return undefined
  }

  return getFormattedDateByTimezone(
    offer.expirationDate,
    offer.location.timezone,
    DMY_CASUAL_LONG_FORMAT,
  )
}
